// extracted by mini-css-extract-plugin
module.exports = {"card":"KpiBig_card_2WTIb","content":"KpiBig_content_2XJfc","titleContainer":"KpiBig_titleContainer_1lnGT","title":"KpiBig_title_14hIx","value":"KpiBig_value_1pxjg"};